import { AlertTriangle } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";

export default function PrivacyPage() {
  const { t } = useLang();
  const c = t.privacy;
  return (
    <main data-testid="privacy-page">
      <Seo title={t.seo.privacy.title} desc={t.seo.privacy.desc} />
      <section className="bg-cream grain pt-32 pb-14 md:pt-40">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <h1 className="font-serif text-4xl sm:text-5xl font-semibold tracking-tight text-espresso">{c.title}</h1>
            <p className="mt-4 text-sm text-espresso/60">{c.updated}</p>
            <div className="mt-6 flex items-start gap-3 rounded-2xl border border-terracotta/40 bg-terracotta/5 p-5" data-testid="privacy-review-flag">
              <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-terracotta" />
              <p className="text-sm font-medium leading-relaxed text-espresso/85">{t.common.reviewFlag}</p>
            </div>
          </Reveal>
        </div>
      </section>
      <section className="bg-white py-14 md:py-20">
        <div className="mx-auto max-w-3xl space-y-10 px-4 sm:px-6 lg:px-8">
          {c.sections.map((sec, i) => (
            <Reveal key={i} delay={0.03 * i}>
              <section data-testid={`privacy-section-${i}`}>
                <h2 className="font-serif text-2xl font-medium text-espresso">{sec.h}</h2>
                {sec.p.map((p, j) => (
                  <p key={j} className="mt-3 text-sm sm:text-base leading-relaxed text-espresso/80">{p}</p>
                ))}
              </section>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
